const ModalContent = ({ text }) => {
  return <p className="margin-bottom-xl">{text}</p>;
};

export default ModalContent;
